var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "v-dropdown" },
    [
      _c(
        "div",
        {
          class: ["v-dropdown__label", _vm.dropdownLabelType],
          on: {
            click: function ($event) {
              return _vm.proxyDisabledHandler(
                _vm.disabled,
                _vm.handleLabelClick
              )
            },
            mouseenter: function ($event) {
              return _vm.proxyDisabledHandler(
                _vm.disabled,
                _vm.handleLabelMouseenter
              )
            },
            mouseleave: function ($event) {
              return _vm.proxyDisabledHandler(
                _vm.disabled,
                _vm.handleLabelMouseleave
              )
            },
          },
        },
        [
          _vm._v(" " + _vm._s(_vm.label) + " "),
          _c("span", { staticClass: "v-icon-down" }),
        ]
      ),
      _c(
        "create-to-body",
        {
          directives: [
            {
              name: "clickoutside",
              rawName: "v-clickoutside",
              value: _vm.hide,
              expression: "hide",
            },
          ],
          class: [_vm.panelClass],
          attrs: { show: _vm.dropdownShow },
        },
        [
          _c(
            "v-scroll",
            {
              ref: "scroll",
              attrs: {
                height: _vm.scrollHeight,
                "is-block": true,
                "to-index": _vm.selectIndex,
              },
              on: { mounted: _vm.setPosition },
            },
            [
              _c(
                "div",
                {
                  staticClass: "v-dropdown__menu",
                  on: {
                    mouseenter: _vm.handleDropdownMouseenter,
                    mouseleave: _vm.handleDropdownMouseleave,
                  },
                },
                [
                  _c(
                    "ul",
                    _vm._l(_vm.options, function (item, idx) {
                      return _c(
                        "li",
                        {
                          key: item.value + idx,
                          class: [
                            "v-dropdown__option",
                            {
                              "v-dropdown__option--divided": item.devided,
                              "v-dropdown__option--active":
                                _vm.selectIndex === idx,
                              "v-dropdown__option--disabled": item.disabled,
                            },
                          ],
                          on: {
                            click: () =>
                              _vm.proxyDisabledHandler(
                                item.disabled,
                                _vm.handleOptionClick,
                                item,
                                idx
                              ),
                          },
                        },
                        [
                          item.icon
                            ? _c("i", {
                                staticClass: "v-dropdown__icon",
                                class: item.icon,
                              })
                            : _vm._e(),
                          _c("span", { staticClass: "v-dropdown__text" }, [
                            _vm._v(_vm._s(item.text)),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }